var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconError = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.98047 9.96094C7.70508 9.96094 9.96094 7.70508 9.96094 4.98047C9.96094 2.26074 7.7002 0 4.97559 0C2.25586 0 0 2.26074 0 4.98047C0 7.70508 2.26074 9.96094 4.98047 9.96094ZM4.97559 5.71289C4.7168 5.71289 4.5752 5.56152 4.56543 5.30273L4.49707 2.89062C4.48731 2.62207 4.69238 2.43164 4.9707 2.43164C5.24414 2.43164 5.45898 2.62695 5.44922 2.89551L5.37598 5.30273C5.36621 5.56641 5.22461 5.71289 4.97559 5.71289ZM4.97559 7.50977C4.69238 7.50977 4.42871 7.28516 4.42871 6.98242C4.42871 6.67969 4.6875 6.45508 4.97559 6.45508C5.26367 6.45508 5.52246 6.6748 5.52246 6.98242C5.52246 7.29004 5.25879 7.50977 4.97559 7.50977Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconError);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-error.8a54a46136086e25df2fd1f96e8241d6.svg";